import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from './../app/apiBaseQuery';

export const AgencyAPI = createApi({
    reducerPath: "AgencyAPI",
    baseQuery,
    tagTypes: ["Recruiters"],
    endpoints: (builder) => ({

        createOrUpdateRecruiter: builder.mutation({
            query: (params) => ({
                url: "user/createRecruiter",
                method: "POST",
                body: params,
            }),
            invalidatesTags: ["Recruiters"],
        }),

        getMyRecruiters: builder.query({
            query: ({ page = 1, perPage = 10 } = {}) => ({
                url: "user/getMyRecruiters",
                method: "POST",
                body: { page, perPage },
            }),
            providesTags: ["Recruiters"],
        }),

        deleteRecruiter: builder.mutation({
            query: (params) => ({
                url: "user/deleteRecruiter",
                method: "POST",
                body: params,
            }),
            invalidatesTags: ["Recruiters"],
        }),

        getAgencyDashbaordStats: builder.query({
            query: (params) => ({
                url: "user/getAgencyDashboard",
                method: "POST",
                body: params,
            }),
        }),

        getRecruiterDashbaordStats: builder.query({
            query: (params) => ({
                url: "user/getRecruiterDashboard",
                method: "POST",
                body: params,
            }),
        }),

    }),
});

export const {
    useCreateOrUpdateRecruiterMutation,
    useGetMyRecruitersQuery,
    useDeleteRecruiterMutation,
    useGetAgencyDashbaordStatsQuery,
    useGetRecruiterDashbaordStatsQuery
} = AgencyAPI;